export const IMPORT_GROUP_MEMBERS = 'IMPORT_GROUP_MEMBERS'
export const IMPORT_GROUP_MEMBERS_REQUEST = 'IMPORT_GROUP_MEMBERS_REQUEST'
export const SETUP_IMPORT_RESULTS_STATE = 'SETUP_IMPORT_RESULTS_STATE'
export const UPDATE_GROUP_MEMBERS_COUNT = 'UPDATE_GROUP_MEMBERS_COUNT'

export const LOCALE_PREFIX = 'components.Dialog.components.GroupMembersImport'

export const DATA_PATH = 'response.success.payload.response.body.problems'
export const FULL_PATH = 'response.success.payload.response.body'
